<div
    class="agpr-viInsightsTab-insights"
    [style.display]="selected ? '' : 'none'"
    role="tabpanel"
    [id]="id"
    [attr.aria-labelledby]="id"
>
    <div class="agpr-viInsightsTab-insights-toolbar">
        <agpr-autocomplete
            [id]="id + '_languageAutocomplete'"
            [ngModel]="selectedLanguageOption"
            (searchStringChanged)="languageChanged({ value: $event, label: $event })"
            (ngModelChange)="languageChanged($event)"
            [suggestions]="languageOptions$"
            [disabled]="isInsightGenerating"
            [clearOnBlur]="false"
            label="Vi.insights.generatedIn"
            [dropdown]="true"
            labelField="label"
            dropdownMode="blank"
            [forceSelection]="false"
            [sortSuggestions]="false"
        ></agpr-autocomplete>

        <div class="agpr-viInsightsTab-insights-brandIdentity">
            <agpr-autocomplete
                [id]="id + '_brandIdentityAutocomplete'"
                class="agpr-viInsightsTab-insights-brandIdentityAutocomplete"
                [(ngModel)]="selectedBrand"
                (ngModelChange)="brandChanged($event)"
                (searchStringChanged)="brandChanged($event)"
                [suggestions]="brandList$"
                [disabled]="isInsightGenerating"
                label="Common.dialog.aeoScout.insights.brandIdentity.autocomplete.label"
                placeholder="Common.dialog.aeoScout.insights.brandIdentity.autocomplete.placeholder"
                tooltipPosition="top"
                [dropdown]="true"
                [customOptions]="selectedBrand ? brandListAutocompleteOptions : []"
                labelField="name"
                [forceSelection]="false"
                [clearOnBlur]="false"
                dropdownMode="current"
            ></agpr-autocomplete>

            <agpr-button
                [id]="id + '_brandIdentityManageButton'"
                class='agpr-viInsightsTab-insights-brandIdentityManageButton'
                [disabled]="isInsightGenerating"
                [style]="buttonType.block"
                icon='fa-regular fa-duotone fa-gear'
                tooltip="Common.brandIdentity.manageDialog.heading"
                tooltipPosition="left"
                (click)="openManageBrandsDialog()"
            ></agpr-button>
        </div>

        @let hasNoBrand = !selectedBrand;
        @if (hasNoBrand) {
            <agpr-message [severity]="messageSeverity.warning" [bottomMargin]="false">
                {{ 'Common.dialog.aeoScout.insights.brandIdentity.warningMessage' | localize }}
            </agpr-message>
        }
    </div>
    <agpr-scroll-panel>
        <ul class="agpr-viInsightsTab-insights-list">
            @for (prompt of prompts; track prompt.analysisType) {
                <li
                    [agprTooltip]="isInsightGenerating ? ('Vi.insights.generating' | localize) : ''"
                    tooltipPosition="top"
                >
                    <agpr-insight-card
                        [id]="prompt.analysisType + '_insightCard'"
                        class="agpr-viInsightsTab-insights-insightCard"
                        [(expanded)]="prompt.expanded"
                        [label]="'Vi.insights.prompt.label.' + prompt.analysisType"
                        [preLabelIcon]="true"
                        [generateDisabled]="isInsightGenerating || (hasNoBrand && !prompt.isCustomPrompt)"
                        [savable]="false"
                        [saved]="false"
                        [isEmpty]="!prompt.insightText"
                        [isAiGenerating]="isInsightGenerating"
                        [isPromptGenerating]="prompt.generating"
                        [collapseOnCancel]="!prompt.isCustomPrompt"
                        (generate)="generateInsight(prompt, true)"
                        (stopGeneration)="cancelGeneration(prompt)"
                    >
                        @if (prompt.isCustomPrompt) {
                            <agpr-textarea-input
                                class="agpr-viInsightsTab-insights-textarea"
                                [(ngModel)]="customPrompt"
                                [disabled]="isInsightGenerating"
                                placeholder="Common.dialog.aeoScout.insights.prompt.enter"
                                icon="fa-kit-duotone fa-agpr-ai-generic"
                            ></agpr-textarea-input>
                            <div class="agpr-viInsightsTab-insights-generateButtonContainer">
                                <agpr-button
                                    [id]="prompt.analysisType + '_generateButton'"
                                    class="agpr-viInsightsTab-insights-generateButton"
                                    tooltipPosition="left"
                                    [tooltip]="hasNoBrand
                                        ? 'Common.dialog.aeoScout.insights.brand.enter'
                                        : (!customPrompt ? 'Common.dialog.aeoScout.insights.prompt.enter' : '' )"
                                    [style]="buttonType.tertiary"
                                    [label]="prompt.aiResponse ? 'Common.dialog.aeoScout.insights.regenerate' : 'Common.dialog.aeoScout.insights.generate'"
                                    [disabled]="
                                        hasNoBrand ||
                                        !customPrompt ||
                                        isInsightGenerating ||
                                        (prompt.customPrompt === customPrompt && matchesCurrentSettings(prompt))
                                    "
                                    (click)="generateInsight(prompt, false)"
                                ></agpr-button>
                            </div>
                        } @else if (prompt.aiResponse) {
                            <div class="agpr-viInsightsTab-insights-generateButtonContainer">
                                <agpr-button
                                    [id]="prompt.analysisType + '_generateButton'"
                                    class="agpr-viInsightsTab-insights-generateButton"
                                    [style]="buttonType.tertiary"
                                    label="Common.dialog.aeoScout.insights.regenerate"
                                    tooltipPosition="left"
                                    [tooltip]="hasNoBrand? 'Common.dialog.aeoScout.insights.brand.enter': ''"
                                    [disabled]="
                                        hasNoBrand ||
                                        isInsightGenerating ||
                                        matchesCurrentSettings(prompt)
                                    "
                                    (click)="generateInsight(prompt, false)"
                                ></agpr-button>
                            </div>
                        }

                        @if (prompt.responseHtml) {
                            <div
                                class="agpr-viInsightsTab-content"
                                [innerHTML]="prompt.responseHtml | LinkiFy:'agpr-viInsightsTab-externalLink' | sanitizeHtml"
                            ></div>
                            <div class="agpr-contextMenu bottom right">
                                <agpr-button
                                    [id]="id + '_copyAnswerButton'"
                                    [style]="buttonType.contextMenu"
                                    icon="fa-kit-duotone fa-agpr-copy"
                                    (click)="copyAnswer($event, prompt.responseHtml)"
                                    tooltip="Vi.copyAnswer"
                                    tooltipPosition="top"
                                ></agpr-button>
                            </div>
                        }
                    </agpr-insight-card>
                </li>
            }
        </ul>
    </agpr-scroll-panel>
</div>
